import { FC } from "react"
import { TravelersList } from "../../../module/travelers/containers/list"

export const TravelersListPage: FC = () => <TravelersList />
